package dk.smark.demo

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.lifecycle.ViewModel
import org.jetbrains.compose.resources.painterResource

import demo.composeapp.generated.resources.Res
import demo.composeapp.generated.resources.compose_multiplatform
import dk.smark.demo.location.GenericLocation
import dk.smark.demo.ui.HomeScreen

@Composable
@Preview
fun App(mapComponent: @Composable (location: GenericLocation) -> Unit = {},
        onUserLocationFound: (lat: Double, lon: Double) -> Unit = {_, _ -> },
        onTrackAvailable: (track: List<GenericLocation>) -> Unit = { _ -> },
        bannerAd: @Composable () -> Unit = {}) {
    MaterialTheme {
        HomeScreen(MainViewModel(), mapComponent, onUserLocationFound, onTrackAvailable, bannerAd)
    }
}